import React from "react";
import { FacebookShareButton, FacebookIcon } from "react-share";
import { BASE_SHARE_TEXT, BASE_URL } from "../data";

interface Props {
  title?: string;
}

export const ShareFacebook = (props: Props) => {
  return (
    <FacebookShareButton
      url={BASE_URL}
      quote={props.title || BASE_SHARE_TEXT}
      hashtag={"CyTrain"}
    >
      <FacebookIcon size={32} round />
    </FacebookShareButton>
  );
};

export default ShareFacebook;
